import { createLockedCalendarEventsStore } from 'owa-calendar-events-store';

export const calendarEventsLockedStore = createLockedCalendarEventsStore();
